module.exports = __webpack_public_path__ + "img/product4-1.83a10faa.png";